import React from 'react';

const Pause = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="25"
    viewBox="0 0 20 20"
  >
    <path
      fill="#fff"
      d="M5.19.094H.84C.43.094.079.413.079.825v16.369c0 .393.332.731.761.731h4.332c.41 0 .76-.319.76-.731V.825a.73.73 0 00-.74-.731zm9.971 0H10.81c-.41 0-.761.319-.761.731v16.369c0 .393.331.731.76.731h4.332c.41 0 .761-.319.761-.731V.825a.73.73 0 00-.741-.731z"
    />
  </svg>
);

export default Pause;
